import { useEffect, useState } from 'react';
import Image from 'next/image';
import { OTPInput } from '@acko-tech/building-blocks.ui.input';
import { getImageBasePath } from 'utils/generics';
import SnackBar from 'library/snackbar';
import * as Styles from './styles';

interface IProps {
    phoneNumber: string;
    onClickEdit: any;
    onClickBack: any;
    onSuccess: any;
}

function OTP({ phoneNumber, onClickEdit, onClickBack, onSuccess }: IProps) {
    const [OTP, setOTP] = useState('');
    const [timer, setTimer] = useState(30);
    const [isValidOTP, setIsValidOTP] = useState(false);
    const [snackbar, setSnackbar] = useState({
        type: '',
        message: '',
    });

    useEffect(() => {
        let intervalId: any;
        if (timer > 0) {
            intervalId = setInterval(() => {
                setTimer(timer - 1);
            }, 1000);
        }
        return () => clearInterval(intervalId);
    }, [timer]);

    useEffect(() => {
        if (isValidOTP) {
            import('./apis').then(async (req) => {
                const { status, errMsg } = await req.verifyOTP(
                    OTP,
                    phoneNumber
                );
                if (status) {
                    onSuccess();
                    return;
                }
                setSnackbar({
                    type: 'failure',
                    message: errMsg || 'Invalid OTP.',
                });
            });
        }
    }, [isValidOTP]);

    const resendOTP = () => {
        import('./apis').then(async (req) => {
            const { status, errMsg } = await req.resendOTP(phoneNumber);
            if (status) {
                setTimer(30);
                return;
            }
            setSnackbar({
                type: 'failure',
                message: errMsg || 'Something went wrong. Please try again',
            });
        });
    };

    return (
        <Styles.Wrapper>
            <Styles.Header>
                <Styles.BackArrowIcon>
                    <Image
                        width={'10px'}
                        height={'24px'}
                        alt={''}
                        src={getImageBasePath('/icons/backArrow.svg')}
                        onClick={onClickBack}
                    />
                </Styles.BackArrowIcon>
            </Styles.Header>
            <Styles.OTPImageWrapper>
                <Image
                    width={'80px'}
                    height={'80px'}
                    alt={''}
                    src={getImageBasePath('/images/otp.svg')}
                />
            </Styles.OTPImageWrapper>
            <Styles.VerificationCodeText>
                Enter verification code
            </Styles.VerificationCodeText>
            <Styles.OTPTextMessageWrapper>
                <Styles.OTPTextMessage>
                    OTP has been sent to {phoneNumber}
                </Styles.OTPTextMessage>
                <Styles.EditIcon>
                    <Image
                        width={'16px'}
                        height={'16px'}
                        alt={''}
                        src={getImageBasePath('/icons/blueEdit.svg')}
                        onClick={onClickEdit}
                    />
                </Styles.EditIcon>
            </Styles.OTPTextMessageWrapper>
            <Styles.OTPInputWrapper>
                <OTPInput
                    OTP={OTP}
                    setOTP={(otp) => setOTP(otp)}
                    setIsValidOTP={(status) => setIsValidOTP(status)}
                    verifyOTPApiResponse={{
                        isVerifyOTPError: false,
                        errorMessage: '',
                    }}
                    sendOTPApiResponse={{
                        isSendOTPError: false,
                        errorMessage: '',
                    }}
                    dataTestId=""
                />
            </Styles.OTPInputWrapper>
            {timer === 0 ? (
                <Styles.ResendLinkText onClick={resendOTP}>
                    Resend OTP
                </Styles.ResendLinkText>
            ) : (
                <Styles.ResendOTPText>
                    Resend OTP in 00:{timer > 9 ? timer : `0${timer}`}
                </Styles.ResendOTPText>
            )}
            <SnackBar
                {...snackbar}
                handleSnakbarComplete={() =>
                    setSnackbar({ type: '', message: '' })
                }
            />
        </Styles.Wrapper>
    );
}

export default OTP;
